import { CHECKOUT_FORM_NAME } from '../constants';
import { ContactFields } from '../models/order';
import { RespondentType } from '../models/questions';
import { CheckoutState } from '../state';
import { getEnablePaymentConstraintsInNewCreate } from './app';
import {
    getIsFreeEvent,
    getIsReservedSeating,
    getSurveyType,
    hasSpecialInstructions,
    isWaitlistEnabled,
} from './event';
import { getFormValues } from './forms';
import { getNamespaceValue } from './utils/selector';

export const hasCannedQuestions = (state: CheckoutState) =>
    getNamespaceValue(
        state.expressCheckout,
        'expressCheckoutConditions.hasCannedQuestions',
        true,
    );

export const hasCustomQuestions = (state: CheckoutState) =>
    getNamespaceValue(
        state.expressCheckout,
        'expressCheckoutConditions.hasCustomQuestions',
        true,
    );

export const isApplePayAvailableAsPaymentMethod = (state: CheckoutState) =>
    getNamespaceValue(
        state.expressCheckout,
        'expressCheckoutConditions.hasApplePay',
        false,
    );

export const isPaypalAvailableAsPaymentMethod = (state: CheckoutState) =>
    getNamespaceValue(
        state.expressCheckout,
        'expressCheckoutConditions.hasPaypal',
        false,
    );

export const isContactInformationComplete = (state: CheckoutState) => {
    const { buyer } = getFormValues(state, CHECKOUT_FORM_NAME) || {};

    return !!(
        buyer?.[ContactFields.EMAIL] &&
        buyer?.[ContactFields.FIRST_NAME] &&
        buyer?.[ContactFields.LAST_NAME]
    );
};

export const hasQuestions = (state: CheckoutState) =>
    hasCannedQuestions(state) || hasCustomQuestions(state);

export const areSyncExpressCheckoutEligibleCommonRulesMet = (
    state: CheckoutState,
) =>
    !getEnablePaymentConstraintsInNewCreate(state) &&
    !getIsFreeEvent(state) &&
    !getIsReservedSeating(state) &&
    !hasSpecialInstructions(state) &&
    !isWaitlistEnabled(state) &&
    (getSurveyType(state) === RespondentType.buyer ||
        getSurveyType(state) === RespondentType.direct);

export const areAsyncExpressCheckoutEligibleCommonRulesMet = (
    state: CheckoutState,
) => !hasQuestions(state);
